import '.a{display:flex;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import '.cf{ms-overflow-style:none;}.ssr-plugin'
import '.cg{scrollbar-width:none;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { useLoading } from '@based/sdk/react'
import { Event } from '@app/components/blocks/event/Event'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { pages } from '@app/util/links'

export const LandingEvents = ({ style }: { style?: Style }) => {
  const isLoading = useLoading()
  const isMobile = useMediaQuery()
  const t = useTranslations()
  const { tenant } = useTenantContext()

  if (tenant?.events.length === 0 && !isLoading) {
    return <div>{t.app.blogPage.noContent}</div>
  }

  return (
    <>
      {isLoading ? (
        <div>{t.app.blogPage.loading}</div>
      ) : (
        <styled.div className="a d cf cg"
          style={{
            overflowX: isMobile ? 'auto' : 'visible',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            ...style,
          }}
        >
          {tenant?.events.map((item, index) => (
            <Event
              key={index}
              date={new Date(item.start).getDate()}
              month={new Date(item.start).toLocaleString('default', {
                month: 'short',
              })}
              intro={item.intro}
              category={item.category || ''}
              title={item.title}
              time={`${new Date(item.start).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              })} - ${new Date(item.end).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              })}`}
              location={item.location?.address || ''}
              to={pages.event(item.slug)}
              style={{
                width: '30rem',
                flexShrink: 0,
              }}
            />
          ))}
        </styled.div>
      )}
    </>
  )
}
